import React from 'react';
import cn from 'classnames';
import { int } from 'common/utils/helpers';
import RelativeSizeValue from 'client/components/common/RelativeSizeValue';
import { SIDE } from '../Points/constants';
import css from './Area.scss';

function getLineProps(side, property) {
	const result = {
		stroke: '#ff4aff',
		strokeWidth: 1,
	};

	if (side === SIDE.region) {
		// @ts-expect-error ts-migrate FIXME
		result.x1 = 0;
		// @ts-expect-error ts-migrate FIXME
		result.y1 = property === 'size-tb' ? 0 : '100%';
		// @ts-expect-error ts-migrate FIXME
		result.x2 = '100%';
		// @ts-expect-error ts-migrate FIXME
		result.y2 = property === 'size-tb' ? '100%' : '0';
	}

	if (side === SIDE.left || side === SIDE.right) {
		// @ts-expect-error ts-migrate FIXME
		result.x1 = 0;
		// @ts-expect-error ts-migrate FIXME
		result.y1 = '50%';
		// @ts-expect-error ts-migrate FIXME
		result.x2 = '100%';
		// @ts-expect-error ts-migrate FIXME
		result.y2 = '50%';
	}

	if (side === SIDE.top || side === SIDE.bottom) {
		// @ts-expect-error ts-migrate FIXME
		result.x1 = '50%';
		// @ts-expect-error ts-migrate FIXME
		result.y1 = 0;
		// @ts-expect-error ts-migrate FIXME
		result.x2 = '50%';
		// @ts-expect-error ts-migrate FIXME
		result.y2 = '100%';
	}

	return result;
}

type Props = {
	side?: string;
	className?: string;
	property: string;
	value: string | string[];
};

const Area = ({ property, value, side, className }: Props) => {
	const style = {
		position: 'absolute',
	};

	// POSITION
	if (property === 'left') {
		Object.assign(style, { top: 0, bottom: 0, right: '100%', width: value });
	}
	if (property === 'right') {
		Object.assign(style, { top: 0, bottom: 0, left: '100%', width: value });
	}
	if (property === 'top') {
		Object.assign(style, { left: 0, right: 0, bottom: '100%', height: value });
	}
	if (property === 'bottom') {
		Object.assign(style, { left: 0, right: 0, top: '100%', height: value });
	}

	// PADDING
	if (property === 'padding-left') {
		Object.assign(style, { top: 0, bottom: 0, left: 0, width: value });
	}
	if (property === 'padding-right') {
		Object.assign(style, { top: 0, bottom: 0, right: 0, width: value });
	}
	if (property === 'padding-top') {
		Object.assign(style, { left: 0, right: 0, top: 0, height: value });
	}
	if (property === 'padding-bottom') {
		Object.assign(style, { left: 0, right: 0, bottom: 0, height: value });
	}

	// SIZE
	const isSize = ['size', 'size-tb', 'size-bt'].includes(property);

	return (
		<div
			className={cn(css.area, className, {
				[css[`area-${side}`]]: Boolean(side),
				[css.size]: isSize,
			})}
			// @ts-expect-error ts-migrate FIXME
			style={style}
		>
			{isSize && (
				<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
					<line {...getLineProps(side, property)} />
				</svg>
			)}
			<span className={css.value}>
				{Array.isArray(value) ? (
					value.map((v, i) => (
						// eslint-disable-next-line react/no-array-index-key
						<React.Fragment key={`rsv-${v}-${i}`}>
							{i === 0 ? '⭤ ' : ' ⭥ '}
							{/* @ts-expect-error ts-migrate FIXME */}
							<RelativeSizeValue value={int(v)} unit=" px" />
						</React.Fragment>
					))
				) : (
					// @ts-expect-error ts-migrate FIXME
					<RelativeSizeValue value={int(value)} unit=" px" />
				)}
			</span>
		</div>
	);
};

Area.defaultProps = {
	className: '',
	side: '',
};

export default Area;
